import React, { useState, useEffect } from "react";
import { Steps, Spin, Modal } from "antd";
import EmailVerify from "./WithdrawalVerify/EmailVerify";
import PhoneVerify from "./WithdrawalVerify/PhoneVerify";
import IDCard from "./WithdrawalVerify/IDCard";
import Address from "./WithdrawalVerify/Address";
const { Step } = Steps;
function OtpPopUp({
    otpVisible,
    otpModal,
    otpParam,
    memberInfo,
    getMemberData,
    readStep,
    coloseVisible,
}) {
    // 初次彈窗顯示，控制彈窗，彈窗類別參數，會員信息
    //const [ readStep, setReadStep ] = useState(1); // 0 選擇驗證框、1 了解更多框   4.密码修改
    const [Loading, setLoading] = useState(false); // 加载 控制狀態
    const [phoneVisible, setPhoneVisible] = useState(false); // 彈手機驗證框
    const [emailVisible, setEmailVisible] = useState(false); // 彈email驗證框
    const [attemptRemaining, setAttemptRemaining] = useState(5); // 电话剩餘次數
    const [emailattemptRemaining, setEmailAttemptRemaining] = useState(5); // 邮箱剩餘次數

    const prams = {
        // 引用參數
        memberInfo: memberInfo && memberInfo,
        closeModal: () => setPhoneVisible(false),
        otpParam: otpParam,
        times: 5,
        attemptRemaining: attemptRemaining,
        setAttemptRemaining: setAttemptRemaining,
        kindOfVerification: false,
        emailattemptRemaining: emailattemptRemaining,
        setEmailAttemptRemaining: setEmailAttemptRemaining,
        coloseVisible: coloseVisible,
        otpModal: otpModal,
    };
    return (
        <React.Fragment>
            <Modal
                title={"账户验证"}
                className={`confirm-modal-of-public`}
                visible={otpVisible}
                closable={true}
                centered={true}
                width={500}
                footer={null}
                zIndex={1500}
                onCancel={() => {
                    otpModal();
                }}
            >
                {
                    <Spin tip="请稍后" spinning={Loading}>
                        <div className="WithdrawalVerification">
                            <div className="VerificationSteps">
                                <Steps current={readStep - 1}>
                                    <Step />
                                    <Step />
                                    <Step />
                                    <Step />
                                </Steps>
                            </div>
                            {/* 第一步 身份证验证 */}
                            {readStep == 1 && (
                                <IDCard
                                    {...prams}
                                    memberInfo
                                    getMemberData={() => {
                                        getMemberData();
                                    }}
                                    setLoading={setLoading}
                                />
                            )}
                            {/* 第二步 联系地址 */}
                            {readStep == 2 && (
                                <Address
                                    {...prams}
                                    setLoading={setLoading}
                                    getMemberData={() => {
                                        getMemberData();
                                    }}
                                />
                            )}

                            {/* 第三步 手机验证 */}
                            {readStep == 3 && (
                                <PhoneVerify
                                    {...prams}
                                    visible={phoneVisible}
                                    phone={
                                        memberInfo.isVerifiedPhone &&
                                        memberInfo.isVerifiedPhone[0]
                                    }
                                    // changeVerify={VerifyCategory}
                                    Description={
                                        <div>
                                            点击”发送”，您的手机将会收到验证码，请输入您收到的验证码以完成本次验证。
                                        </div>
                                    }
                                    callCS={
                                        <div className="otp-cs-tip">
                                            如果您想更新手机号码，请联系我们的
                                            <span
                                                className="otp-cs"
                                                onClick={() => {
                                                    global.PopUpLiveChat();
                                                    Pushgtagdata("CS_loginOTP");
                                                }}
                                            >
                                                在线客服
                                            </span>
                                        </div>
                                    }
                                    modalTitle={`手机验证`}
                                    // setReadStep={setReadStep}
                                    kindOfVerifications={
                                        "WithdrawalVerification"
                                    }
                                    getMemberData={() => {
                                        getMemberData();
                                    }}
                                />
                            )}
                            {/* 第四步 邮箱验证 */}
                            {readStep == 4 && (
                                <EmailVerify
                                    {...prams}
                                    visible={emailVisible}
                                    email={
                                        memberInfo.isVerifiedEmail &&
                                        memberInfo.isVerifiedEmail[0]
                                    }
                                    // changeVerify={VerifyCategory}
                                    Description={
                                        <div style={{ textAlign: "justify" }}>
                                            验证电子邮箱
                                            点击“发送”，您的电子邮箱将会收到验证码，请输入您收到的验证码以完成本次验证。
                                        </div>
                                    }
                                    callCS={
                                        <div className="otp-cs-tip">
                                            如果您想更新电子邮箱，请联系我们的
                                            <span
                                                className="otp-cs"
                                                onClick={() => {
                                                    global.PopUpLiveChat();
                                                    Pushgtagdata("CS_loginOTP");
                                                }}
                                            >
                                                在线客服
                                            </span>
                                        </div>
                                    }
                                    // setReadStep={setReadStep}
                                    kindOfVerifications={
                                        "WithdrawalVerification"
                                    }
                                />
                            )}
                        </div>
                    </Spin>
                }
            </Modal>
        </React.Fragment>
    );
}

export default OtpPopUp;
